/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Used_ExcellentInputs */

const en_val_used_excellent = /** @type {(inputs: Val_Used_ExcellentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Used - Excellent`)
};

const es_val_used_excellent = /** @type {(inputs: Val_Used_ExcellentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usado - Excelente`)
};

const fr_val_used_excellent = /** @type {(inputs: Val_Used_ExcellentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Occasion - Excellent`)
};

const de_val_used_excellent = /** @type {(inputs: Val_Used_ExcellentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebraucht - Ausgezeichnet`)
};

const ja_val_used_excellent = /** @type {(inputs: Val_Used_ExcellentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中古 - 非常に良い`)
};

const zh_val_used_excellent = /** @type {(inputs: Val_Used_ExcellentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`二手 - 极佳`)
};

const ar_val_used_excellent = /** @type {(inputs: Val_Used_ExcellentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مستعمل - ممتاز`)
};

const id_val_used_excellent = /** @type {(inputs: Val_Used_ExcellentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekas - Sangat Baik`)
};

const it_val_used_excellent = /** @type {(inputs: Val_Used_ExcellentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usato - Eccellente`)
};

const ru_val_used_excellent = /** @type {(inputs: Val_Used_ExcellentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Б/У - В отличном состоянии`)
};

const pt_val_used_excellent = /** @type {(inputs: Val_Used_ExcellentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usado - Excelente`)
};

const ko_val_used_excellent = /** @type {(inputs: Val_Used_ExcellentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`중고 - 매우 좋음`)
};

/**
* | output |
* | --- |
* | "Used - Excellent" |
*
* @param {Val_Used_ExcellentInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_used_excellent = /** @type {((inputs?: Val_Used_ExcellentInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Used_ExcellentInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_used_excellent(inputs)
	if (locale === "es") return es_val_used_excellent(inputs)
	if (locale === "fr") return fr_val_used_excellent(inputs)
	if (locale === "de") return de_val_used_excellent(inputs)
	if (locale === "ja") return ja_val_used_excellent(inputs)
	if (locale === "zh") return zh_val_used_excellent(inputs)
	if (locale === "ar") return ar_val_used_excellent(inputs)
	if (locale === "id") return id_val_used_excellent(inputs)
	if (locale === "it") return it_val_used_excellent(inputs)
	if (locale === "ru") return ru_val_used_excellent(inputs)
	if (locale === "pt") return pt_val_used_excellent(inputs)
	return ko_val_used_excellent(inputs)
});